var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vetPrescriptionInfo && _vm.vetPrescriptionItemList)?_c('div',[_c('my-canvas',{attrs:{"params":_vm.params,"width":1400}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }